
import styled, { css } from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';

export const Card = styled.div`
    display: flex; 
    flex-direction: column;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    position: relative;
    padding: 3rem 4rem;
    border: 2px solid #f4f4f4;    
    position: relative;

    ${breakpoint('xs','md')`  
        padding: 3rem 2rem;


    `}


`

export const Title = styled.h3`
    font-style: bold;

`

export const Content = styled.p`
    margin-top: 0.5rem;

`


export const Icon = styled.div`
    position:absolute;
    top:-35%;
    transform: translateY(35%);
    height: 5rem;
    width: 5rem;
    border: 1px solid #3c6382;
    background-color: #fff;
    border-radius: 50%; 
    display:flex;
    align-items: center;
    justify-content: center;   


`